<template>
  <div>
    <v-card>
      <v-app-bar color="grey lighten-2" dense elevation="0">
        <v-toolbar-title>{{ translate($store.getters.content.timeslots) }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-card-text class="ma-0 pa-0">
        <v-expansion-panels multiple>
          <v-expansion-panel v-for="(item, i) in timeSlotsGroupedByDate" :key="i">
            <v-expansion-panel-header>
              <div>{{ formatDateTime(i) }}</div>
              <v-spacer />
              <v-avatar size="20" color="success" style="flex: none" class="white--text me-2" v-if="getSlotTypeCount(item, 'AVAILABLE') > 0">{{
                getSlotTypeCount(item, 'AVAILABLE')
              }}</v-avatar>
              <v-avatar size="20" color="primary" style="flex: none" class="white--text me-2" v-if="getSlotTypeCount(item, 'RESERVED_APP') > 0">{{
                getSlotTypeCount(item, 'RESERVED_APP')
              }}</v-avatar>
              <v-avatar
                size="20"
                color="secondary"
                style="flex: none"
                class="white--text me-2"
                v-if="getSlotTypeCount(item, 'RESERVED_DASHBOARD') > 0"
                >{{ getSlotTypeCount(item, 'RESERVED_DASHBOARD') }}</v-avatar
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class scope="row">{{ translate($store.getters.content.duration) }}</th>
                      <th class="text-left" scope="row">{{ translate($store.getters.content.state) }}</th>
                      <th class="text-center" scope="row">{{ translate($store.getters.content.action) }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="slot in item" :key="slot.id">
                      <td>{{ slot.duration }} {{ translate($store.getters.content.minutes) }}</td>
                      <td>
                        <v-chip small outlined :color="getSlotColor(slot.state)">{{ getSlotStateChip(slot.state) }}</v-chip>
                      </td>
                      <td style="text-align: right">
                        <v-btn
                          small
                          class="px-5"
                          color="success"
                          v-if="slot.state == 'AVAILABLE'"
                          @click="openBookingDialog(slot)"
                          :disabled="slot.loader"
                        >
                          <span v-if="slot.loader">
                            <v-progress-circular indeterminate :size="20" :width="2"></v-progress-circular>
                            {{ translate($store.getters.content.updating) }}
                          </span>
                          <span v-else>{{ translate($store.getters.content.book) }}</span>
                        </v-btn>
                        <v-btn small color="success" v-else disabled>{{ translate($store.getters.content.booked) }}</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <div class="pa-8 text-center title" v-if="!loadingSlots && !hasSlots">{{ translate($store.getters.content.no_slots_date) }}</div>
    </v-card>
    <template v-if="loadingSlots">
      <v-skeleton-loader
        v-for="(page, i) in 10"
        :key="'skeletonloader-' + i"
        type="list-item"
        ref="skeleton"
        class="mx-auto my-0"
      ></v-skeleton-loader>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  props: ['selectedDate', 'location'],
  mixins: [SharedFunctions],
  data() {
    return {};
  },
  computed: {
    hasSlots() {
      if (Object.keys(this.timeSlotsGroupedByDate).length > 0) return true;
      else return false;
    },
    // selectedDate() {
    //   return this.$store.state.appointmentsSelectedDayPage.selectedDate;
    // },
    timeSlotsGroupedByDate() {
      if (this.$store.state.appointmentsSelectedDayPage.timeSlots.length > 0)
        return this.groupByTimeSlot(this.$store.state.appointmentsSelectedDayPage.timeSlots);
      else return {};
    },
    loadingSlots() {
      return this.$store.state.appointmentsSelectedDayPage.loadingSlots;
    },
    // location() {
    //   return this.$store.getters.location;
    // },
    caseInfo() {
      return this.$store.getters.getPatientCase;
    },
    code() {
      return this.$store.state.intakeFormData.code;
    }
  },
  created() {
    this.getEntriesOnDate();
  },
  methods: {
    getEntriesOnDate() {
      if (this.selectedDate) {
        this.$store.dispatch('GET_CALENDAR_DAY_SLOTS', {
          minDate: this.selectedDate,
          maxDate: this.selectedDate,
          location: this.location,
          code: this.code.code
        });
      }
    },
    formatDateTime(d) {
      return moment
        .utc(d, 'YYYY-MM-DDTHH:mm')
        .local()
        .format('hh:mm A');
    },
    groupByTimeSlot(data) {
      let result = data
        .filter(item => item.state == 'AVAILABLE')
        .reduce(function(r, a) {
          r[a.date] = r[a.date] || [];
          r[a.date].push(a);
          return r;
        }, Object.create(null));

      return result;
    },
    getSlotTypeCount(slots, type) {
      if (!slots) return;
      let items = slots.filter(slot => {
        return slot.state == type;
      });
      return items.length;
    },

    getSlotStateChip(state) {
      if (state == 'AVAILABLE') {
        //return 'Open';
        return this.$store.getters.content.open[this.$store.state.config.selectedLanguage];
      } else if (state == 'RESERVED_APP') {
        return 'App';
      } else if (state == 'RESERVED_DASHBOARD') {
        return 'Dashboard';
      }
    },
    getSlotColor(state) {
      if (state == 'AVAILABLE') {
        return 'success';
      } else if (state == 'RESERVED_APP') {
        return 'primary';
      } else if (state == 'RESERVED_DASHBOARD') {
        return 'secondary';
      }
    },
    openBookingDialog(slot) {
      this.$store.commit('SET_SELECTED_SLOT', slot);
      this.$store.commit('SET_SELECTED_DATE_TIME_APPOINTMENT', slot.date);
      this.$store.commit('SET_APPOINTMENT_BOOKING_DIALOG', true);
    }
  }
};
</script>

<style lang="scss">
.v-list-item__title {
  text-transform: uppercase;
}
.v-toolbar__title {
  text-transform: none;
}
</style>
